import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, CircularProgress, FormControl } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AccountLink, SubTitle, Title } from '../common';
import KenInput from '../../../Components/KenInput';
import KenButton from '../../../Components/KenButton';
import KenPhoneInput from '../../../Components/KenPhoneInput';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Constants/routes';
import LoginBG from '../../../Assets/Svg/login-bg.svg';
import MobileLoginBG from '../../../Assets/Svg/login-mobile-bg.svg';
import { Controller, useForm } from 'react-hook-form';
import validator from 'validator';
import { requestOneTimeOtp } from '../api';
import { useSnackbar } from 'notistack';
import { REGEX } from '../../../Constants/constant';
import AuthLayout from '../AuthLayout';
import { matchIsValidTel } from 'mui-tel-input';
import { handleError } from '../util';

const useStyles = makeStyles((theme) => ({
  customDatePicker: {
    '& .react-date-picker__calendar': {
      zIndex: 2,
    },
    '& .react-date-picker__wrapper': {
      border: 0,
      borderRadius: '4px',
      padding: '6px 16px',
      backgroundColor: '#F3F5F7',
      textAlign: 'left',
      '&:focus': {
        backgroundColor: theme.palette.KenColors.kenWhite,
      },
      '& input': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__inputGroup__divider': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__button': {
        paddingRight: 0,
      },
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundImage: `url(${LoginBG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
    },
    [theme.breakpoints.up('sm')]: {
      height: '100%',
    },

    '& form': {
      top: () => (1 / window.devicePixelRatio === 1 ? '50%' : 0),
      transform: () =>
        1 / window.devicePixelRatio === 1 ? 'translateY(-50%)' : 0,
      position: () => (1 / window.devicePixelRatio === 1 ? 'relative' : 0),
    },
  },
  loginContent: {
    // boxShadow:
    //   '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    float: 'right',
    // height: '100%',
    marginRight: "100px",
    backgroundColor: "white",
    marginTop: "40px",
    margin: "0px !important",
    opacity: "0.8",
    width: "32vw",
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
      marginRight: "0px",
    },
    [`@media (min-height: 500px) and (max-height: 650px)`]: {
      marginTop: '10px'
    },
    [`@media (min-height: 650px) and (max-height: 700px)`]: {
      marginTop: '-40px !important'
    },
    [`@media (min-height: 700px) and (max-height: 750px)`]: {
      marginTop: '50px'
    },
    [`@media (min-height: 750px) and (max-height: 1000px)`]: {
      marginTop: '130px'
    },
    [`@media (min-width: 350px) and (max-width: 370px)`]: {
      boxShadow: 'none',
      marginRight: "0px",
    },
    [`@media (min-width: 370px) and (max-width: 400px)`]: {
      boxShadow: 'none',
      marginRight: "10px",
    },
    [`@media (min-width: 400px) and (max-width: 450px)`]: {
      boxShadow: 'none',
      marginRight: "25px",
    },
    [`@media (min-width: 450px) and (max-width: 550px)`]: {
      boxShadow: 'none',
      marginRight: "50px",
    },
    [`@media (min-width: 550px) and (max-width: 600px)`]: {
      boxShadow: 'none',
      marginRight: "100px",
    },
    [`@media (min-width: 350px) and (max-width: 700px)`]: {
      marginTop: "-25px",
      width: "-webkit-fill-available"
    },
    [theme.breakpoints.down('xs')]: {
      boxShadow: 'none',
      marginRight: "20px",
    },
    '& .scrollbar-container': {
      marginTop: '10px !important',
      maxWidth: '500px',
      minHeight: '520px',
      padding: '20px 40px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '16px',
        paddingRight: '16px',
        maxWidth: '360px',
      },
      [theme.breakpoints.up('sm')]: {
        maxHeight: '600vh',
        overflowY: 'auto',
      },
      [`@media (min-height: 500px) and (max-height: 600px)`]: {
        height: '520px'
      },
    },
  },
  title: {
    margin: () =>
      1 / window.devicePixelRatio !== 1 ? '0 auto 16px auto' : '0 0 16px 0',
  },
  subTitle: {
    margin: () =>
      1 / window.devicePixelRatio !== 1 ? '0 auto 32px auto' : '0 0 32px 0',
  },
  inputFieldLabel: {
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '100%',
    textTransform: 'capitalize',
    color: theme.palette.KenColors.grey2,
  },
  verify: {
    width: '100%',
    height: '48px',
    marginBottom: '40px',
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '#092682 !important',
    background: '#f6c445 !important',
    fontFamily: 'Poppins,sans-serif',
  },
  signupWith: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '100%',
    color: theme.palette.KenColors.neutral100,
  },
  signupWithItem: {
    margin: '0 8px',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    boxShadow:
      '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    '& img': {
      height: '24px',
      width: '24px',
    },
  },
  phoneContainer: {
    display: 'flex',
    '& .phone-input': {
      fontFamily: 'Poppins,sans-serif',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '100%',
      color: theme.palette.KenColors.grey2,
      padding: '16px',
      order: 2,
      background: '#F3F5F7',
      border: 0,
      height: '48px',
      borderRadius: '4px',
      marginLeft: '11px',
      '&::placeholder': {
        fontSize: '16px',
        lineHeight: '100%',
        color: '#A8AFBC',
        fontFamily: 'Poppins,sans-serif',
      },
    },
    '& .phone-dropdown': {
      position: 'relative',
      order: 1,
      border: 0,
      background: '#F3F5F7',
      '&.open': {
        background: '#F3F5F7',
        '& .selected-flag': {
          background: '#F3F5F7',
        },
      },
      '& .selected-flag': {
        width: '50px',
        padding: '10px',
        '&:hover': {
          background: '#F3F5F7',
        },
      },
    },
  },
}));

const email = (value) => validator.isEmail(value);

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { control, handleSubmit } = useForm({
    defaultValues: {
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      phone: '',
    },
    mode: 'onChange',
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await requestOneTimeOtp({
        id: data.email,
        phone: data?.phone,
      });

      if (res?.success) {
        navigate(routes.verifyEmail, {
          state: { ...data, accountId: '0015g00000EB9mGAAT' },
        });
      }
    } catch (error) {
      const errorMessage =
        error && error?.response?.data
          ? Array.isArray(error?.response?.data?.errorMessages)
            ? error?.response?.data?.errorMessages[0]?.errorMessage
            : error?.response?.data?.errorMessage
          : 'Something went wrong';
      if (
        errorMessage.includes('Email already exists') ||
        errorMessage.includes('duplicate record')
      ) {
        setTimeout(() => {
          navigate(routes.login);
        }, 2000);
      }
      enqueueSnackbar(errorMessage, {
        variant: 'error',
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box className={classes.loginContent}>
          <PerfectScrollbar>
            <Title className={classes.title} text="Get Started!" />
            <SubTitle
              className={classes.subTitle}
              text="Sign Up to start using this platform."
            />
            <FormControl fullWidth style={{ marginBottom: '24px' }}>
              <Controller
                name="firstName"
                control={control}
                rules={{
                  required: 'This field is Required',
                  maxLength: {
                    value: 40,
                    message: 'This field cannot be more than 40 characters',
                  },
                  pattern: {
                    message: 'Please input a correct value',
                    value: REGEX.NAME,
                  },
                  validate: (value) => {
                    return (
                      /^[A-Z]/.test(value) ||
                      'Please input first letter as capital letters'
                    );
                  },
                }}
                render={({ field, fieldState: { error } }) => {
                  return (
                    <KenInput
                      required
                      name="firstName"
                      label="First Name"
                      placeholder="Enter First Name"
                      errorLabel={false}
                      labelClassName={classes.inputFieldLabel}
                      {...field}
                      error={error?.message || error?.type}
                    />
                  );
                }}
              />
            </FormControl>
            <FormControl fullWidth style={{ marginBottom: '24px' }}>
              <Controller
                name="lastName"
                control={control}
                rules={{
                  required: 'This field is Required',
                  maxLength: {
                    value: 40,
                    message: 'This field cannot be more than 40 characters',
                  },
                  pattern: {
                    message: 'Please input a correct value',
                    value: REGEX.LASTNAME,
                  },
                }}
                render={({ field, fieldState: { error } }) => {
                  return (
                    <KenInput
                      required
                      name="lastName"
                      label="Last Name"
                      placeholder="Enter Last Name"
                      errorLabel={false}
                      labelClassName={classes.inputFieldLabel}
                      {...field}
                      error={error?.message || error?.type}
                    />
                  );
                }}
              />
            </FormControl>
            <FormControl fullWidth style={{ marginBottom: '24px' }}>
              <Controller
                name="email"
                control={control}
                rules={{
                  required: 'This field is Required',
                  pattern: {
                    value: REGEX.EMAIL,
                    message: 'Please enter a valid email',
                  },
                  validate: email,
                }}
                render={({ field, fieldState: { error } }) => {
                  return (
                    <KenInput
                      required
                      name="email"
                      label="Email"
                      placeholder="Enter Email"
                      labelClassName={classes.inputFieldLabel}
                      errorLabel={false}
                      {...field}
                      error={error?.message || error?.type}
                    />
                  );
                }}
              />
            </FormControl>
            <FormControl
              fullWidth
              style={{ marginBottom: '24px', alignItems: 'start' }}
            >
              <Controller
                name="phone"
                control={control}
                rules={{
                  required: 'This field is required',
                  validate: (value) => {
                    return (
                      matchIsValidTel(value) ||
                      'Please enter a valid phone number'
                    );
                  },
                }}
                render={({ field, fieldState: { error } }) => {
                  return (
                    <KenPhoneInput
                      inputFieldLabelClass={`${classes.inputFieldLabel}`}
                      variant="outlined"
                      errorLabel={true}
                      required={true}
                      label={"Phone number"}
                      {...field}
                      error={error?.message}
                    />
                  );
                }}
              />
            </FormControl>
            <Box width="100%">
              <KenButton
                variant="roundedButton"
                buttonClass={classes.verify}
                type="submit"
                disabled={loading}
              >
                Verify
              </KenButton>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '49%',
                    transform: 'translate(-50%, -50%)',
                  }}
                />
              )}
            </Box>
            <Box
              display={'flex'}
              justifyContent="center"
              alignItems={'center'}
              width="100%"
            >
              <AccountLink
                text="Already Have An Account?"
                actionText={'Log In'}
                onAction={() => navigate(routes.login)}
              />
            </Box>
          </PerfectScrollbar>
        </Box>
      </form>
    </AuthLayout>
  );
}
